import {
  CostSharingIcon,
  InstanceApproveIcon,
  LocatorIcon,
  PlansIcon,
} from "./Icons";
import { useContent } from "../../i18n";
import "./style.scss";

const icons = [
  <PlansIcon />,
  <InstanceApproveIcon />,
  <CostSharingIcon />,
  <LocatorIcon />,
];

export const Features = () => {
  const { members } = useContent();

  return (
    <div id="features" className="features-wrapper">
      <div className="container">
        <h2>{members.featuresTitle}</h2>
        <div className="feature-cards-wrapper">
          {members.features.map((feature, i) => (
            <div className="feature-card" key={feature.t}>
              {icons[i]}
              <h3>{feature.t}</h3>
              <p>{feature.d}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
